// removed by extract-text-webpack-plugin
module.exports = {"Base":"ArticleBlock__Base-2i_GE","Base--stretched":"ArticleBlock__Base--stretched-Kz6sw ArticleBlock__Base-2i_GE","Figure":"ArticleBlock__Figure-3i09F CategoryHero__Figure-20aWY","Header":"ArticleBlock__Header-2f7Jx","Content":"ArticleBlock__Content-3yNKj","FigureLink":"ArticleBlock__FigureLink-26m5z CategoryHero__FigureLink-39UJJ","Image":"ArticleBlock__Image-3Mvzk CategoryHero__Image-ldOGJ","Title":"ArticleBlock__Title-mULmZ","Title--sans":"ArticleBlock__Title--sans-2kBM6 ArticleBlock__Title-mULmZ","Title--serif":"ArticleBlock__Title--serif-D2eNg ArticleBlock__Title-mULmZ","Title--large":"ArticleBlock__Title--large-3phcp ArticleBlock__Title-mULmZ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ArticleBlock/ArticleBlock.css
 ** module id = 622
 ** module chunks = 0
 **/